var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.isMounted)?_c('forms-container',{attrs:{"investor_id":_vm.InvestorId,"investor_status":_vm.InvestorStatus,"user_id":_vm.UserId,"moral-tabs":_vm.moralTabs,"pfae-tabs":_vm.pfaeTabs,"full-disabled":true}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }